@if (notifications().length > 0) {
  <div class="notifications-container">
    @if (hasDismissibleNotifications()) {
      <div class="notifications-toolbar">
        <button class="btn btn-primary btn-withIcon" (click)="dismissAllNotifications()" type="button">
          <span class="icon icon-Close" aria-hidden="true"></span>
          {{ 'notifications.dismissAll' | translate }}
        </button>
      </div>
    }
    <div class="notifications-list">
      @for (notification of notifications(); track notification.id) {
        <div
          class="notification-card"
          [class.severity-info]="notification.severity === NotificationSeverity.INFO"
          [class.severity-warning]="notification.severity === NotificationSeverity.WARNING"
          [class.severity-error]="notification.severity === NotificationSeverity.ERROR"
          [class.notification-card--new]="
            notification.type === NotificationType.WORKFLOW_STARTED || notification.type === NotificationType.SERVICE_TASK_CREATED
          "
          [class.notification-card--completed]="
            notification.type === NotificationType.WORKFLOW_COMPLETED || notification.type === NotificationType.SERVICE_TASK_COMPLETED
          "
          [class.notification-card--overdue]="
            notification.type === NotificationType.WORKFLOW_OVERDUE || notification.type === NotificationType.SERVICE_TASK_OVERDUE
          "
          [class.clickable]="isClickable(notification)"
          [attr.role]="isClickable(notification) ? 'button' : null"
          [attr.tabindex]="isClickable(notification) ? 0 : null"
          (click)="onNotificationClick(notification)"
          (keydown.enter)="onNotificationClick(notification)"
        >
          <div class="notification-header">
            <h4 class="notification-card-title">{{ titleKey(notification) | translate }}</h4>
            @if (canDismiss(notification)) {
              <button
                class="notification-dismiss-button"
                [attr.aria-label]="'notifications.dismiss' | translate"
                (click)="dismissNotification(notification, $event)"
                type="button"
              >
                <mat-icon class="notification-dismiss-icon">close</mat-icon>
              </button>
            }
          </div>

          <p class="notification-description">{{ descriptionKey(notification) | translate: descriptionParams(notification) }}</p>

          <div class="notification-meta">
            <span class="date-value">{{ notification.createdAt | localizedDate: false : true : false : true }}</span>
          </div>
        </div>
      }
    </div>
  </div>
} @else {
  <div class="no-notifications">
    <p class="no-notifications-message">{{ 'notifications.noNotifications' | translate }}</p>
  </div>
}
